__turbopack_context__.v({
  "clickable-overlay": "mochi-drawer-module-scss-module__oIaT6a__clickable-overlay",
  "dark-mode": "mochi-drawer-module-scss-module__oIaT6a__dark-mode",
  "drawer-container": "mochi-drawer-module-scss-module__oIaT6a__drawer-container",
  "drawer-content": "mochi-drawer-module-scss-module__oIaT6a__drawer-content",
  "drawer-layout": "mochi-drawer-module-scss-module__oIaT6a__drawer-layout",
  "light-mode": "mochi-drawer-module-scss-module__oIaT6a__light-mode",
  "rounded": "mochi-drawer-module-scss-module__oIaT6a__rounded",
  "show": "mochi-drawer-module-scss-module__oIaT6a__show",
});
